import { useEffect } from 'react';
import RadioGroup from '../../../ui/radio-group';
import Input from '../../../ui/input';
import Text from '../../../ui/text';
import { useFormContext } from "react-hook-form";

function OtherInsuranceCoverageForm() {
  const { 
    watch,
    register,
    control,
    resetField,
    formState: { errors },
  } = useFormContext();

  const watchOtherInsuranceCoverage = watch('otherInsuranceCoverage');
  const watchotherPrescriptionDrugCoverage = watch('otherPrescriptionDrugCoverage');
  const watchOtherMedicalServicesCoverage = watch('otherMedicalServicesCoverage');

  useEffect(() => {
    if (!watchOtherInsuranceCoverage) {
      resetField('insuranceName');
      resetField('insuranceId');
      resetField('insuranceGroup');
    }
  }, [watchOtherInsuranceCoverage]);

  useEffect(() => {
    if (!watchotherPrescriptionDrugCoverage) {
      resetField('otherPrescriptionDrugCoverageName');
      resetField('otherPrescriptionDrugCoverageMemberNumber');
      resetField('otherPrescriptionDrugCoverageGroupNumber');
    }
  }, [watchotherPrescriptionDrugCoverage]);

  useEffect(() => {
    if (!watchOtherMedicalServicesCoverage) {
      resetField('otherMedicalServicesCoverageName');
      resetField('otherMedicalServicesCoverageMemberNumber');
    }
  }, [watchOtherMedicalServicesCoverage]);

  return (
    <section className="w-full">
      <h2 className="text-2xl font-semibold leading-none text-secondary">
        <Text>Other Insurance Coverage *</Text>
      </h2>
      <div className='w-full flex flex-col justify-start items-start mt-5'>
        <RadioGroup
          control={control}
          name='otherInsuranceCoverage'
          size='sm'
          options={[
            { label: <Text>Yes</Text>, value: true },
            { label: <Text>No</Text>, value: false }
          ]} 
          isInvalid={!!errors?.otherInsuranceCoverage}
          errorMessage={errors?.otherInsuranceCoverage?.message || null}
        />
      </div>
      {watchOtherInsuranceCoverage && (
        <div className="grid grid-cols-12 gap-5 mt-5">
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='insuranceName'>Name *</Text>
            <Input
              {...register('insuranceName')}
              size='sm'
              label={<Text>Name</Text>}
              placeholder="-"
              errorMessage={errors?.insuranceName?.message || null}
              isInvalid={errors?.insuranceName ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='insuranceId'>Identifier (ID) *</Text>
            <Input
              {...register('insuranceId')}
              size='sm'
              label={<Text>Identifier (ID)</Text>}
              placeholder="-"
              errorMessage={errors?.insuranceId?.message || null}
              isInvalid={errors?.insuranceId ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='insuranceGroup'>Group *</Text>
            <Input
              {...register('insuranceGroup')}
              size='sm'
              label={<Text>Group</Text>}
              placeholder="-"
              errorMessage={errors?.insuranceGroup?.message || null}
              isInvalid={errors?.insuranceGroup ? true : false}
            />
          </div>
        </div>
      )}
      <div className='mt-5'>
        <Text type='label' htmlFor='otherPrescriptionDrugCoverage'>Will you have other prescription drug coverage (like VA, TRICARE) in addition to Solis?</Text>
      </div>
      <div className='w-full flex flex-col justify-start items-start mt-5'>
        <RadioGroup
          control={control}
          name='otherPrescriptionDrugCoverage'
          size='sm'
          options={[
            { label: <Text>Yes</Text>, value: true },
            { label: <Text>No</Text>, value: false }
          ]} 
          isInvalid={!!errors?.otherPrescriptionDrugCoverage}
          errorMessage={errors?.otherPrescriptionDrugCoverage?.message || null}
        />
      </div>
      {watchotherPrescriptionDrugCoverage && (
        <div className="grid grid-cols-12 gap-5 mt-5">
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='otherPrescriptionDrugCoverageName'>Name of Other Coverage *</Text>
            <Input
              {...register('otherPrescriptionDrugCoverageName')}
              size='sm'
              label={<Text>Name of Other Coverage</Text>}
              placeholder="-"
              errorMessage={errors?.otherPrescriptionDrugCoverageName?.message || null}
              isInvalid={errors?.otherPrescriptionDrugCoverageName ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='otherPrescriptionDrugCoverageMemberNumber'>Member Number *</Text>
            <Input
              {...register('otherPrescriptionDrugCoverageMemberNumber')}
              size='sm'
              label={<Text>Member Number</Text>}
              placeholder="-"
              errorMessage={errors?.otherPrescriptionDrugCoverageMemberNumber?.message || null}
              isInvalid={errors?.otherPrescriptionDrugCoverageMemberNumber ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='otherPrescriptionDrugCoverageGroupNumber'>Group Number *</Text>
            <Input
              {...register('otherPrescriptionDrugCoverageGroupNumber')}
              size='sm'
              label={<Text>Group Number</Text>}
              placeholder="-"
              errorMessage={errors?.otherPrescriptionDrugCoverageGroupNumber?.message || null}
              isInvalid={errors?.otherPrescriptionDrugCoverageGroupNumber ? true : false}
            />
          </div>
        </div>
      )}
      <div className='mt-5'>
        <Text type='label' htmlFor='otherPrescriptionDrugCoverage'>
          Do you have other health insurance that will cover medical services? Examples: other employer coverage, LTD coverage, worker’s compensation, auto liability, or VA benefits.
        </Text>
      </div>
      <div className='w-full flex flex-col justify-start items-start mt-5'>
        <RadioGroup
          control={control}
          name='otherMedicalServicesCoverage'
          size='sm'
          options={[
            { label: <Text>Yes</Text>, value: true },
            { label: <Text>No</Text>, value: false }
          ]} 
          isInvalid={!!errors?.otherMedicalServicesCoverage}
          errorMessage={errors?.otherMedicalServicesCoverage?.message || null}
        />
      </div>
      {watchOtherMedicalServicesCoverage && (
        <div className="grid grid-cols-12 gap-5 mt-5">
          <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='otherMedicalServicesCoverageName'>Name of Health Insurance Company *</Text>
            <Input
              {...register('otherMedicalServicesCoverageName')}
              size='sm'
              label={<Text>Name</Text>}
              placeholder="-"
              errorMessage={errors?.otherMedicalServicesCoverageName?.message || null}
              isInvalid={errors?.otherMedicalServicesCoverageName ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='otherMedicalServicesCoverageMemberNumber'>Member Number *</Text>
            <Input
              {...register('otherMedicalServicesCoverageMemberNumber')}
              size='sm'
              label={<Text>Member Number</Text>}
              placeholder="-"
              errorMessage={errors?.otherMedicalServicesCoverageMemberNumber?.message || null}
              isInvalid={errors?.otherMedicalServicesCoverageMemberNumber ? true : false}
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default OtherInsuranceCoverageForm;